import React, { useEffect, Suspense }  from 'react';
import { Spin } from 'antd';
import { Router, Switch, Route } from 'react-router-dom'
import Loadable from 'react-loadable';
// import { useSafeAppsSDK } from '@gnosis.pm/safe-apps-react-sdk';
import { history } from './routes/history';

const loading = () => (
  <div className="animated fadeIn pt-3 text-center"><Spin /></div>
);

const LayoutFrontend = Loadable({
  loader: () => import('./layout/LayoutFrontend'),
  loading
});

const Welcome = Loadable({
  loader: () => import('./section/home/Welcome'),
  loading
});

const Dao = Loadable({
  loader: () => import('./section/dao/Dao'),
  loading
});

function App() {
  // const { sdk, connected, safe } = useSafeAppsSDK();

  // useEffect(() => {
  //   console.log('Safe: ', safe);
  // }, []);

  return (
    
    <div className="App">
      <Suspense fallback = {null}>
      <Router history={history}>
        <Switch>
          <Route path="/" exact name="Wellcome" component={Welcome} />
          <Route path='/dao'>
            <Dao />
          </Route>
          <Route path="/*"  name="Frontend" component={LayoutFrontend} />
        </Switch>
      </Router>
      </Suspense>
    </div>
  );
}

export default App;
